import type { EqualizeFieldNamesProvider } from './interfaces'

export function getPlatformEqualizeFieldNamesProvider(): EqualizeFieldNamesProvider {
  return () => ({
    semanticFieldNames: [
      'vectorEnrichmentDomainSpecific',
      'vectorEnrichmentFoundationalModel',
      'semantic_suggestions',
    ],
    sponsoredFieldNames: ['sponsored'],
  })
}
